import React, { useEffect, useState } from "react";

export const UserContext = React.createContext("");

export const UserProvider = ({ children }: any) => {
	const [userId, setUserId] = useState("");

	useEffect(() => {
		setUserId("TENNIS");
	}, []);

	return (
		<UserContext.Provider value={userId}> {children} </UserContext.Provider>
	);
};
